// Module
var code = "<div class=\"comments-count\"> <svg aria-hidden=\"true\" role=\"img\" viewBox=\"0 0 18 18\"> <use xlink:href=\"assets/icons/defs.svg#icon-comments\"></use> </svg> <span class=\"comments-count__title\">{{ commentsCount.numberComments }}</span> </div> ";
// Exports
module.exports = code;